

angular
    .module('tmx-common')
    .factory('sharedProperties', function () {
        var data =
                {
                    property: 'Dashboard'
                };
            
        return {
            getProperty: function () {
                return data.property;
            },
            setProperty: function (property) {
                data.property = property;
            }
        };
        
    })
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    .factory('sharedCompany', function(){
        var company = {
            name: ''
        };
        return{
            getProperty: function () {
                return company.name;
            },
            setProperty: function (CompName) {
                company.name = CompName;
            }
        }
    })
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    .factory('sharedURLinfo', function(){
        var URL = {
            Req: '',
            Res: ''
        };
        return{
            getReqURL: function () {
                return URL.Req;
            },
            getResURL: function () {
                return URL.Res;
            },
            setReqURL: function (url) {
                URL.Req = url;
            },
            setResURL: function (url) {
                URL.Res = url;
            }

        }
    })
    .factory('cacheStore', function () {
        var data = {};
    
        return {
            get: function (key) {
                return data[key];
            },
            set: function (key,value) {
                data[key] = value;
            },
            remove: function (key) {
                data[key] = undefined;
            },
            removeAll: function() {
                data = {};
            },
            hasKey: function(key){
                return data.hasOwnProperty(key);
            },
            getKeys: function(){
                return Object.keys(data);
            }
        };

    });